import { createContext, useContext, ReactNode } from 'react';

/**
 * @description Context that signals whether the current page is the job list page.
 * Used by FilterButton to determine visibility without any URL-based detection.
 */
const JobListRouteContext = createContext<boolean>(false);

export const JobListRouteProvider = ({ children }: { children: ReactNode }) => (
  <JobListRouteContext.Provider value>
    {children}
  </JobListRouteContext.Provider>
);

export const useIsJobListRoute = () => useContext(JobListRouteContext);
